import APIServices from 'services/APIServices';
import Axios from './Axios';

export const fetchProjectBoard = async (projectBoardId, boardData = []) => {
  try {
    return await APIServices.get(`/project-board/${projectBoardId}`);
  } catch (error) {
    console.error('Error fetching permissions:', error);
    return null;
  }
};

export const fetchProjectMilestonesByBoard = async (projectBoardId, isArchived = false) => {
  try {
    const response = await APIServices.get(`/project-milestone?projectBoardId=${projectBoardId}&isArchived=${isArchived}`);
    if (response.length > 0) {
      return response;
    }
  } catch (error) {
    console.error('Error fetching permissions:', error);
  }
};

export const createProjectBoard = async (workspaceName, projectId, isProjectRelatedBoard = true, parentBoardId) => {
  try {
    const payload = {
      workspaceName,
      isProjectRelatedBoard
    };
    if (projectId) {
      payload.projectId = projectId;
    }
    if (parentBoardId) {
      payload.parentBoardId = parentBoardId;
    }
    return await Axios.post('/project-board', payload);
  } catch (error) {
    console.error('Error Fetching Projects:', error);
    throw error;
  }
};

export const fetchMilestoneDetail = async (milestoneId) => {
  try {
    return await APIServices.get(`/project-milestone/${milestoneId}`);
  } catch (error) {
    console.error('Error fetching permissions:', error);
  }
};

export const fetchSubtaskDetail = async (subtaskId) => {
  try {
    return await Axios.get(`/milestone-subtask/detail/${subtaskId}`);
  } catch (error) {
    console.error('Error fetching permissions:', error);
  }
};

export const fetchEnumOptions = async (enumName) => {
  try {
    return await APIServices.get(`/enum?item_type=${enumName}`); // Adjust the URL as necessary
  } catch (error) {
    console.error('Error fetching permissions:', error);
  }
};
